import React from 'react'
import Banner from '../home/banner/banner'
import Footer from '../footer/footer'
import { Tabs } from 'antd'
import RightBtn from '../rightBtn/rightBtn';
import DocumentMeta from 'react-document-meta';
require('./electricity.scss')
require('./mobile_electricity.scss')
import { Get, wrapResponse } from './../../requst'
const TabPane = Tabs.TabPane;


function callback(key) {
    (key);
}

export default class Electricity extends React.Component {
    static async getInitialProps(ctx) {
        const [data, seo, caseRes, news] = await Promise.all([
            wrapResponse(Get({ url: 'saas/banner' })),
            wrapResponse(Get({ url: 'saas/seo' })),
            wrapResponse(Get({ url: 'saas/case' })),
            wrapResponse(Get({ url: 'saas/news' })),
        ])

        const footerProps = await Footer.getInitialProps()

        return { data, seo, case: caseRes, news, footerProps }
    }

    constructor(props, context) {
        super(props, context)
        this.state = {

        }

    }
    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    case() {
        return this.props.case.map((item, index) => (
            <a href={`/casedetails/${item.id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} key={index}>
                <img className="Img" style={{ width: '100%' }} src={item.thumb} alt="" />
                <div className="TextBox" style={{ textAlign: 'center' }}>
                    <p>{item.title}</p>
                    {/*<p>{item.desc.substring(0,40)}</p>*/}
                </div>
                <div className="Line"></div>
                <div className="Mask"></div>
            </a>
        ))
    }
    news() {
        return this.props.news.map((item, index) => (
            <a href={`/details/${item.id}`} key={index}>
                <div className="ImgBox">
                    <img className="Img" src={item.thumb} alt="" />
                </div>
                <p className="P_Con P_Head">{item.title.length > 24 ? `${item.title.substring(0, 24)}...` : item.title}</p>
                <p className="P_Con P_Text">{item.desc.length > 24 ? `${item.desc.substring(0, 24)}...` : item.desc}</p>
                <div className="Mask_DeatilsBtm"></div>
                <div className="Triangle"></div>
                <div className="MaskText">
                    <p>{item.created_at.substring(0, 7)}</p>
                    <p>{item.created_at.substring(8, 10)}</p>
                    <img src={require('../../assets/common/images/anniujiantou-bai.png')} alt="" />
                </div>
            </a>
        ))
    }
    render() {
        // (document.body.offsetWidth)
        if (this.state.offsetWidth >= 1200) {

            if (this.props.seo) {
                const meta = {
                    title: this.props.seo.title,
                    description: this.props.seo.description,
                    // link: {
                    //   rel: {
                    //     canonical: 'http://example.com/path/to/sub-page'
                    //   }
                    // },
                    meta: {
                        charSet: 'utf-8',
                        name: {
                            keywords: this.props.seo.keywords
                        },
                    },
                    extend: true
                };
                return (
                    <DocumentMeta {...meta}>
                        <div>
                            <div style={{ width: '100%', height: '630px', display: 'flex', justifyContent: 'center' }}>
                                <img src={this.props.data ? this.props.data[0].photos : null} style={{ height: '100%' }} alt="" />
                            </div>
                            <div className="SaaS_Middle_one">
                                <div className="ContainerBox">
                                    <p className="Title">SaaS服务<span>优势</span></p>
                                    <p className="SubTitle">专业的电商SaaS系统及服务提供商，为企业提供全方位电商解决方案， 凭借在IT领域丰富的经验以。</p>
                                    <ul className="Content">
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/gongnengduo-hui.png')} alt="" />
                                                <p className="True_Title">功能多</p>
                                            </div>
                                            <div className="False">
                                                <img src={require('../../assets/common/images/gongnengduo.png')} alt="" />
                                                <p className="False_Title">功能多</p>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>·  代理商授权系统</td>
                                                            <td>·  团队管理系统</td>
                                                        </tr>
                                                        <tr>
                                                            <td>·  防伪溯源系统</td>
                                                            <td>·  返利结算系统</td>
                                                        </tr>
                                                        <tr>
                                                            <td>·  物流跟踪系统</td>
                                                            <td>·  发货系统</td>
                                                        </tr>
                                                        <tr>
                                                            <td>·  订单管理系统</td>
                                                            <td>·  库存管理系统</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <span className="BottomLine"></span>
                                        </li>
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/xitongkuai-hui.png')} alt="" />
                                                <p className="True_Title">系统快</p>
                                            </div>
                                            <div className="False">
                                                <img src={require('../../assets/common/images/xitongkuai-bai.png')} alt="" />
                                                <p className="False_Title">系统快</p>
                                                <p className="P_Cont">·  订单自动快速下载</p>
                                                <p className="P_Cont">·  系统日处理量超1亿单</p>
                                                <p className="P_Cont">·  实现高速智能审单</p>
                                                <p className="P_Cont">·  比一般ERP系统速度快30倍</p>
                                            </div>
                                            <span className="BottomLine"></span>
                                        </li>
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/fuwuhao-hui.png')} alt="" />
                                                <p className="True_Title">服务好</p>
                                            </div>
                                            <div className="False">
                                                <img src={require('../../assets/common/images/fuwuhao-bai.png')} alt="" />
                                                <p className="False_Title">服务好</p>
                                                <p className="P_Text">
                                                    我们在全国已设立了40个线下服务分支机构，服务范围覆盖超过253个城市，超过900人的服务团队为客户提供及时、周到和专业的服务。
                                            </p>
                                            </div>
                                            <span className="BottomLine"></span>
                                        </li>
                                        <li>
                                            <div className="True">
                                                <img src={require('../../assets/common/images/xhengbensheng-hui.png')} alt="" />
                                                <p className="True_Title">成本省</p>
                                            </div>
                                            <div className="False">
                                                <img src={require('../../assets/common/images/xhengbensheng-bai.png')} alt="" />
                                                <p className="False_Title">成本省</p>
                                                <p className="P_Text">米粒优选，日均发货1万3千单以上，使用聚水潭后效率提高3倍，一年节省成本254万 </p>
                                            </div>
                                            <span className="BottomLine"></span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="SaaS_Middle_two">
                                <div className="ContainerBox">
                                    <p className="Title">八大基础<span>功能</span></p>
                                    <p className="SubTitle">全方位协调企业玩转微商，让微商更简单</p>
                                    <ul className="Content">
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">01</p>
                                            </div>
                                            <p className="TextTitle">代理商授权系统</p>
                                            <p className="Text">代理授权、自定义授权证书样式、实时查询授权真伪</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">02</p>
                                            </div>
                                            <p className="TextTitle">团队管理系统</p>
                                            <p className="Text">代理删除、拉黑、查询、自动升级、方便灵活管理团队,提升团队业绩</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">03</p>
                                            </div>
                                            <p className="TextTitle">订单管理系统</p>
                                            <p className="Text">杜绝错单漏单交易全流程可控可追溯</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">04</p>
                                            </div>
                                            <p className="TextTitle">防伪溯源系统</p>
                                            <p className="Text">保证分销者拿到正品可追溯商品的流通动向</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">05</p>
                                            </div>
                                            <p className="TextTitle">返利结算系统</p>
                                            <p className="Text">系统自动完成所有业绩的计算,推荐奖、业绩奖、管理奖等等</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">06</p>
                                            </div>
                                            <p className="TextTitle">库存管理系统</p>
                                            <p className="Text">让库存管理更轻松</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">07</p>
                                            </div>
                                            <p className="TextTitle">发货系统</p>
                                            <p className="Text">让发货管理更加便捷快速</p>
                                        </li>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', }}>
                                                <img src={require('../../assets/common/images/gongneng-tu.png')} alt="" />
                                                <p className="Head">08</p>
                                            </div>
                                            <p className="TextTitle">物流跟踪系统</p>
                                            <p className="Text">随时随地查询最新物流动向</p>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            {this.props.case ? <div className="SaaS_Middle_three">
                                <p className="Title">SaaS开发<span>案例</span></p>
                                <ul className="Content">
                                    {this.case()}
                                </ul>
                                <a href={"/caseshow?key=3"} className="Button">
                                    更多
                                    </a>
                            </div> : null}
                            <div className="SaaS_Process">
                                <div className="ContainerBox">
                                    <p className="Title">四大升级功能</p>
                                    <div className="TabBox">
                                        <Tabs tabBarGutter={120} tabPosition={'left'} defaultActiveKey="1" onChange={callback}>
                                            <TabPane tab="订单管理" key="1">
                                                <img className="Process_Img" src={require('../../assets/common/images/dingdanguanli.png')} alt="" />
                                                <p className="Process_Text"> 利用已售采购建议科学制定采购计划 在途库存、采购到货精细管控 采购入库高效快速、精准无误，支持库存一键平移、越库直发 实现档口、供应商、生产厂家零障碍协同，不限分销商数量和开店数量线上分销与线下分销并存 支持自行发货和一件代发 支持自营、经销与代销并存 支持供销-分销价格体系管控 支持多级分销，支持分销对账管理多平台、多店铺库存,实时同步，精准库存,缺货预警不超卖进销库存一目了然 手持PDA全仓无纸化操作 拣货路径最优化 支持员工绩效考核  </p>
                                            </TabPane>
                                            <TabPane tab="仓储管理" key="2">
                                                <img className="Process_Img" src={require('../../assets/common/images/cangchuguanli.png')} alt="" />
                                                <p className="Process_Text"> 利用已售采购建议科学制定采购计划 在途库存、采购到货精细管控 采购入库高效快速、精准无误，支持库存一键平移、越库直发 实现档口、供应商、生产厂家零障碍协同，不限分销商数量和开店数量线上分销与线下分销并存 支持自行发货和一件代发 支持自营、经销与代销并存 支持供销-分销价格体系管控 支持多级分销，支持分销对账管理多平台、多店铺库存,实时同步，精准库存,缺货预警不超卖进销库存一目了然 手持PDA全仓无纸化操作 拣货路径最优化 支持员工绩效考核  </p>
                                            </TabPane>
                                            <TabPane tab="分销管理" key="3">
                                                <img className="Process_Img" src={require('../../assets/common/images/fenxiaoguanli.png')} alt="" />
                                                <p className="Process_Text"> 利用已售采购建议科学制定采购计划 在途库存、采购到货精细管控 采购入库高效快速、精准无误，支持库存一键平移、越库直发 实现档口、供应商、生产厂家零障碍协同，不限分销商数量和开店数量线上分销与线下分销并存 支持自行发货和一件代发 支持自营、经销与代销并存 支持供销-分销价格体系管控 支持多级分销，支持分销对账管理多平台、多店铺库存,实时同步，精准库存,缺货预警不超卖进销库存一目了然 手持PDA全仓无纸化操作 拣货路径最优化 支持员工绩效考核  </p>
                                            </TabPane>
                                            <TabPane tab="协同供应链" key="4">
                                                <img className="Process_Img" src={require('../../assets/common/images/xietonggongyinglian.png')} alt="" />
                                                <p className="Process_Text"> 利用已售采购建议科学制定采购计划 在途库存、采购到货精细管控 采购入库高效快速、精准无误，支持库存一键平移、越库直发 实现档口、供应商、生产厂家零障碍协同，不限分销商数量和开店数量线上分销与线下分销并存 支持自行发货和一件代发 支持自营、经销与代销并存 支持供销-分销价格体系管控 支持多级分销，支持分销对账管理多平台、多店铺库存,实时同步，精准库存,缺货预警不超卖进销库存一目了然 手持PDA全仓无纸化操作 拣货路径最优化 支持员工绩效考核  </p>
                                            </TabPane>
                                        </Tabs>
                                    </div>

                                </div>
                            </div>
                            {this.props.news ? <div className="SaaS_Middle_four">
                                <p className="Title">电商SaaS<span>资讯</span></p>
                                <ul className="Buttom">
                                    {this.news()}
                                </ul>
                                <a href={`/newscenter?key=3`} >更多</a>
                            </div> : null}
                            <Footer {...this.props.footerProps} />
                            <RightBtn props={this.props} />
                        </div>
                    </DocumentMeta>

                )
            } else {
                return null
            }
        } else {
            return (
                <div className="Mobile_Electricity">
                    <div className="Mobile_ShowBox">
                        <p className="Mobile_Title">SaaS服务<span>优势</span></p>
                        <p className="Mobile_SubTitle">专业的电商SaaS系统及服务提供商，为企业提供全方位电商解决方案， 凭借对现代市场的敏锐感知，融合大数据、云计算、SaaS、移动互联网等先进技术，引领着中国电商服务行业的发展方向。</p>
                        <div className="Mobile_SaaS">
                            <div>
                                <img src={require('../../assets/common/images/gongnengduo-hui@3x.png')} alt="" />
                                <p className="Mobile_SaaSHead">功能多</p>
                                <p className="Line"></p>
                            </div>
                            <div>
                                <img src={require('../../assets/common/images/xitongkuai@3x.png')} alt="" />
                                <p className="Mobile_SaaSHead">系统快</p>
                                <p className="Line"></p>
                            </div>
                            <div>
                                <img src={require('../../assets/common/images/fuwuhao@3x.png')} alt="" />
                                <p className="Mobile_SaaSHead">服务好</p>
                                <p className="Line"></p>
                            </div>
                            <div>
                                <img src={require('../../assets/common/images/xhengbensheng@3x.png')} alt="" />
                                <p className="Mobile_SaaSHead">成本省</p>
                                <p className="Line"></p>
                            </div>
                        </div>
                    </div>
                    <div className="Mobile_Func">
                        <p className="Mobile_Title">八大基础<span>功能</span></p>
                        <p className="Mobile_SubTitle">全方位协调企业玩转微商，让微商更简单</p>
                        <div className="Mobile_ContentBox">
                            <div>
                                <p className="Mobile_ContantOrder">01</p>
                                <p className="Mobile_ContentTitle">代理商授权系统</p>
                                <p className="Mobile_ContentText">代理授权、自定义授权证书样式、实时查询授权真伪</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">02</p>
                                <p className="Mobile_ContentTitle">团队管理系统</p>
                                <p className="Mobile_ContentText">代理删除、拉黑、查询,自动升级、方便灵活管理、提升团队业绩</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">03</p>
                                <p className="Mobile_ContentTitle">订单管理系统</p>
                                <p className="Mobile_ContentText">杜绝错单漏单交易全流程可控可追溯</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">04</p>
                                <p className="Mobile_ContentTitle">防伪溯源系统</p>
                                <p className="Mobile_ContentText">保证分销者拿到正品可追溯商品的流通动向</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">05</p>
                                <p className="Mobile_ContentTitle">返利结算系统</p>
                                <p className="Mobile_ContentText">系统自动完成所有业绩的计算,推荐奖、业绩奖、管理奖等</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">06</p>
                                <p className="Mobile_ContentTitle">库存管理系统</p>
                                <p className="Mobile_ContentText">让库存管理更轻松</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">07</p>
                                <p className="Mobile_ContentTitle">发货系统</p>
                                <p className="Mobile_ContentText">让发货管理更加便捷快速</p>
                            </div>
                            <div>
                                <p className="Mobile_ContantOrder">08</p>
                                <p className="Mobile_ContentTitle">物流跟踪系统</p>
                                <p className="Mobile_ContentText">随时随地查询最新物流动向</p>
                            </div>
                        </div>
                    </div>
                    <div className="Mobile_Case">
                        <p className="Mobile_Title">开发案例</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                </tr>
                                <tr>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                    <td><img src={require('../../assets/common/images/shiyan.jpg')} alt="" /></td>
                                </tr>
                            </tbody>
                        </table>
                        <button></button>
                    </div>
                </div>
            )
        }
    }
}